import type { ComponentType, SVGProps } from 'react';
import { Cpu } from 'lucide-react';
import { EntityChip } from './EntityChip';

export interface AgentTypeChipProps {
  /** Agent type id (e.g. `claude-code`, `codex`). */
  agentType: string;
  /** Optional display name; falls back to the raw `agentType` id. */
  name?: string;
  /**
   * Optional brand/vendor glyph. The host can pass the agent-type registry
   * icon; when omitted a generic `Cpu` glyph is used.
   */
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  className?: string;
  'data-testid'?: string;
}

/**
 * Standardized chip for an agent type. Shows the agent's brand/vendor glyph
 * and name, with a hover preview resolved through the `agent-types`
 * resource-preview kind.
 */
export function AgentTypeChip({
  agentType,
  name,
  icon: Icon = Cpu,
  className,
  'data-testid': dataTestId,
}: AgentTypeChipProps) {
  return (
    <EntityChip
      kind="agent-types"
      id={agentType}
      icon={<Icon className="h-3 w-3" aria-hidden="true" />}
      label={name ?? agentType}
      className={className}
      data-testid={dataTestId}
    />
  );
}
